import { PublicJobDto } from '@mi-front/api-clients';
import { Query } from '@tanstack/react-query';

export function refetchIntervalForJob(query: Query<any, any, PublicJobDto>) {
  const data = query.state.data;

  if (data?.status === 'WAITING' || data?.status === 'IN_PROGRESS') {
    return 2000;
  }

  return false;
}
